/**
 * 平台区分
 */

const SupportedPlatform = {
  Android: 'Android',
  iOS: 'iPhone',
  QQBrowser: 'QQBrowser',
  UCBrowser: 'UCBrowser',
  Alipay: 'Alipay',
  AlipayMini: 'AliPayMini',
  WeChat: 'MicroMessenger',
  WeChatMini: 'WeChatMini',
  WeChatWork: 'wxwork',
  TouTiao: 'TouTiao',
  TouTiaoMini: 'TouTiaoMini',
  RelxMe: 'RelxMe',
  RelxMeRN: 'RelxMeRN',
};

type TPlaftformType = keyof typeof SupportedPlatform;

type TPlaftform = {
  now: TPlaftformType[];
  is: (maybe: TPlaftformType | TPlaftformType[]) => boolean;
  Supported: typeof SupportedPlatform;
};

const Platform: TPlaftform = {
  now: [],
  is(maybe) {
    if (Array.isArray(maybe)) {
      const ans = maybe.map(plat => this.now.indexOf(plat) > -1).find(x => x);
      return !!ans;
    }
    return this.now.indexOf(maybe) > -1;
  },
  Supported: SupportedPlatform,
};

const boot = () => {
  const UA = window.navigator.userAgent.toLowerCase();
  Object.keys(SupportedPlatform).forEach(key => {
    const plat = SupportedPlatform[key as TPlaftformType];
    const is = UA.indexOf(plat.toLowerCase()) > -1;
    if (is) {
      Platform.now.push(key as TPlaftformType);
    }
  });
  console.log(Platform);
};

const polyfill = () => {
  if (!(window as any).mttLongPressVar) {
    (window as any).mttLongPressVar = {};
  }
};

export { Platform, boot, polyfill };
